// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import OrderLinePhoto from "./order-line-photo.js"
import PhotoProduct from "./photo-product.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "photo_product_id": {
      "column": {
        "default": null,
        "name": "photo_product_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_type": {
      "column": {
        "default": null,
        "name": "photo_session_type",
        "null": true,
        "type": "string"
      },
      "name": "photo_session_type",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "sales_price": {
      "column": null,
      "name": "sales_price",
      "selected_by_default": null,
      "translated": null
    },
    "sales_price_with_vat": {
      "column": null,
      "name": "sales_price_with_vat",
      "selected_by_default": null,
      "translated": null
    },
    "visible_in_shop": {
      "column": {
        "default": false,
        "name": "visible_in_shop",
        "null": false,
        "type": "boolean"
      },
      "name": "visible_in_shop",
      "selected_by_default": null,
      "translated": null
    },
    "translated_photo_session_type": {
      "column": null,
      "name": "translated_photo_session_type",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "TenantPhotoProduct",
  "collectionKey": "tenant_photo_products",
  "collectionName": "tenant_photo_products",
  "i18nKey": "tenant_photo_product",
  "camelizedLower": "tenantPhotoProduct",
  "name": "TenantPhotoProduct",
  "nameDasherized": "tenant-photo-product",
  "pluralName": "tenant_photo_products",
  "ransackable_associations": [
    {
      "className": "BundleOrderLine",
      "collectionName": "bundle_order_lines",
      "foreignKey": "tenant_photo_product_id",
      "name": "bundle_order_lines",
      "macro": "has_many",
      "resource_name": "BundleOrderLine",
      "through": null
    },
    {
      "className": "BundleTenantPhotoProduct",
      "collectionName": "bundle_tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "bundle_tenant_photo_products",
      "macro": "has_many",
      "resource_name": "BundleTenantPhotoProduct",
      "through": null
    },
    {
      "className": "TenantShopSetting",
      "collectionName": "tenant_shop_settings",
      "foreignKey": "default_tenant_photo_sheet_product_id",
      "name": "default_tenant_photo_sheet_product_on_tenant_shop_settings",
      "macro": "has_many",
      "resource_name": "TenantShopSetting",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "OrderLinePhoto",
      "collectionName": "order_line_photos",
      "foreignKey": "tenant_photo_product_id",
      "name": "order_line_photos",
      "macro": "has_many",
      "resource_name": "OrderLinePhoto",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "photo_product_id",
      "name": "photo_product",
      "macro": "belongs_to",
      "resource_name": "PhotoProduct",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "tenant_photo_product_id",
      "name": "photo_sheet_product_order_lines",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "photo_product_id",
      "column": {
        "default": null,
        "name": "photo_product_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "photo_session_type",
      "column": {
        "default": null,
        "name": "photo_session_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "sales_price_cents",
      "column": {
        "default": null,
        "name": "sales_price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "sales_price_currency",
      "column": {
        "default": "DKK",
        "name": "sales_price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "visible_in_shop",
      "column": {
        "default": false,
        "name": "visible_in_shop",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "OrderLinePhoto",
      "collectionName": "order_line_photos",
      "foreignKey": "tenant_photo_product_id",
      "name": "order_line_photos",
      "macro": "has_many",
      "resource_name": "OrderLinePhoto",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "photo_product_id",
      "name": "photo_product",
      "macro": "belongs_to",
      "resource_name": "PhotoProduct",
      "through": null
    }
  ],
  "paramKey": "tenant_photo_product",
  "primaryKey": "id"
}

/** Frontend model for TenantPhotoProduct. */
export default class TenantPhotoProduct extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoProductId() {
    return this.readAttributeUnderscore("photo_product_id")
  }

  /** @returns {boolean} */
  hasPhotoProductId() {
    const value = this.photoProductId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoSessionType() {
    return this.readAttributeUnderscore("photo_session_type")
  }

  /** @returns {boolean} */
  hasPhotoSessionType() {
    const value = this.photoSessionType()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {any} */
  salesPrice() {
    return this.readAttributeUnderscore("sales_price")
  }

  /** @returns {boolean} */
  hasSalesPrice() {
    const value = this.salesPrice()

    return this._isPresent(value)
  }

  /** @returns {any} */
  salesPriceWithVat() {
    return this.readAttributeUnderscore("sales_price_with_vat")
  }

  /** @returns {boolean} */
  hasSalesPriceWithVat() {
    const value = this.salesPriceWithVat()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  visibleInShop() {
    return this.readAttributeUnderscore("visible_in_shop")
  }

  /** @returns {boolean} */
  hasVisibleInShop() {
    const value = this.visibleInShop()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedPhotoSessionType() {
    return this.readAttributeUnderscore("translated_photo_session_type")
  }

  /** @returns {boolean} */
  hasTranslatedPhotoSessionType() {
    const value = this.translatedPhotoSessionType()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./order-line-photo.js").default>} */
  orderLinePhotos() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["tenant_photo_product_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "order_line_photos",
        model: this,
        modelClass: OrderLinePhoto
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./order-line-photo.js").default>>} */
  loadOrderLinePhotos() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["tenant_photo_product_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "order_line_photos",
        model: this,
        modelClass: OrderLinePhoto
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./order-line-photo.js").default>>} */
  ensureOrderLinePhotosLoaded() {
    return this.ensureAssociationLoaded("order_line_photos")
  }

  /** @returns {import("./photo-product.js").default | null} */
  photoProduct() {
    return this._readBelongsToReflection({modelClass: PhotoProduct, reflectionName: "photo_product"})
  }

  /** @returns {Promise<import("./photo-product.js").default | null>} */
  loadPhotoProduct() {
    if (!("photoProductId" in this)) throw new Error("Foreign key method wasn't defined: photoProductId")

    const id = this.photoProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_product",
        model: this,
        modelClass: PhotoProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-product.js").default | null>} */
  ensurePhotoProductLoaded() {
    return this.ensureAssociationLoaded("photo_product")
  }
}
